
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import resource from './ProjectHighlight.module.css'
import { useProjectDetails } from '../../../Hooks/Features/ProjectHighlight/useProjectDetails.js';
import { useCommon } from '../../../Hooks/Common/useCommon.js';
import { useNavigate } from "react-router-dom";
import { AgGridReact } from '@ag-grid-community/react';


function ProjectDetails() {
    const navigate = useNavigate();
    const { checkPermission } = useCommon();
    const { tagRef, onFilterTextBoxChanged, SelectTab, getResourceData, generateJson, columnDefs, gridRef, rowData } = useProjectDetails();

    return (
        <div ref={() => checkPermission("Resource", tagRef)}>
            <div ref={tagRef} id='{"tabname": "Resource", "data": "project_highlight_filter_btn"}' className="col-md-4 col-xs-12" style={{ display: 'flex', width: '100%', marginBottom: '20px', marginTop: '20px' }} >
                <div className={resource["cust-search"]}>
                    <FontAwesomeIcon icon="fas fa-search" style={{ marginLeft: "10px" }} />
                    <input
                        className={resource["inputbox"]}
                        type="text"
                        id="filter-text-box"
                        // placeholder="Filter..."
                        onInput={onFilterTextBoxChanged}
                    />
                    <div ref={tagRef} style={{ border: "1px solid #ccc", padding: "0px 10px", borderRadius: "40px", display: 'inline-block' }}>
                        <button className={SelectTab === " " ? "poker-filter-active" : "poker-filter"} value='All' onClick={(e) => getResourceData(" ")}>All</button>
                        <button className={SelectTab === "d" ? "poker-filter-active" : "poker-filter"} value='Team' onClick={(e) => getResourceData("d")}>Team</button>
                        <button className={SelectTab === "o" ? "poker-filter-active" : "poker-filter"} value='DevOps' onClick={(e) => getResourceData("o")}>DevOps</button>
                        <button className={SelectTab === "e" ? "poker-filter-active" : "poker-filter"} value='Ext. Tea ?m' onClick={(e) => getResourceData("e")} style={{ border: '0px !important;' }}>Ext. Team</button>
                    </div>          
                      </div>
                      <div style={{position:"absolute",right:'23px'}} className='button btn-default'onClick={() => navigate("/project-highlight", {})}>
                    <FontAwesomeIcon icon="fa-solid fa-arrow-left"/> Back
                    </div> 
            </div>

            <div ref={() => checkPermission("Resource", tagRef)}>
                <div ref={() => checkPermission("Project Highlight", tagRef)} >
                    {
                        <button ref={tagRef} id='{"tabname": "Project Highlight", "data": "project_highlight_permission_generate_btn"}' onClick={generateJson}><FontAwesomeIcon icon="fa-solid fa-shield" /> Permissions</button>
                    }
                </div>
                <div ref={tagRef} id='{"tabname": "Resource", "data": "project_highlight_li"}' className="ag-theme-alpine" style={{ height: '80vh', width: '100%' }}>
                    <AgGridReact columnDefs={columnDefs} ref={gridRef} rowData={rowData} rowHeight={30}   
                     headerHeight={30} />
                </div>
            </div>

        </div>
    )
}

export default ProjectDetails;